import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Laura Gómez',
  handle: '@laurabeauty.studio',
  text: 'Pasé de cobrar $30.000 ARS por limpieza a $150.000 ARS por sesión. El módulo de negocio me abrió los ojos. En 2 meses recuperé la inversión del curso y ahora tengo agenda llena.'
}, {
  name: 'Sofía Martínez',
  handle: '@sofia.aesthetics',
  text: 'Empecé desde cero, con mucho miedo. La forma en que explican la anatomía y las zonas seguras me dio la confianza para empezar. Hoy tengo mi propio espacio.'
}, {
  name: 'Elena Ruiz',
  handle: '@elenaruiz_skin',
  text: 'Ya era esteticista pero sentía que me estancaba. Añadir estos protocolos premium me permitió duplicar mis ingresos mensuales trabajando menos horas.'
}];
export const Testimonials = () => {
  return <section className="py-16 bg-base" data-id="element-276">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-277">
        <div className="text-center mb-12" data-id="element-278">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-main mb-3" data-id="element-279">
            Historias de{' '}
            <span className="text-fuchsia italic" data-id="element-280">transformación real</span>
          </h2>
          <p className="text-text-muted max-w-xl mx-auto" data-id="element-281">
            Mujeres que tomaron la decisión de invertir en sí mismas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-282">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-3xl p-7 shadow-sm border border-pink-light relative" data-id="element-283">
              <Quote className="absolute top-5 right-5 w-7 h-7 text-pink-medium" data-id="element-284" />

              <div className="flex gap-1 mb-4" data-id="element-285">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-286" />)}
              </div>

              <p className="text-text-main text-sm leading-relaxed italic mb-5" data-id="element-287">
                "{testimonial.text}"
              </p>

              <div className="pt-4 border-t border-pink-light" data-id="element-288">
                <p className="font-bold text-text-main text-sm" data-id="element-289">
                  {testimonial.name}
                </p>
                <p className="text-xs text-fuchsia" data-id="element-290">{testimonial.handle}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};